import { baseComponentApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function AttachmentList(props: { title: string; attachments: baseComponentApi.AttachmentBase[] }) {
  const context = useWebAppContext()
  const tErr = useTranslation('errors')

  const { title, attachments } = props

  return (
    <div className='grid grid-cols-12'>
      <p className='col-span-11 col-start-1 my-[8px] text-[16px] font-semibold leading-[24px] text-[#4A4A4A] md:col-span-11 md:col-start-1'>
        {title}
      </p>
      {attachments.map((attach) => (
        <div key={attach.id} className='col-span-11 col-start-1'>
          <Button
            label={attach.name}
            text
            className='my-[2px] p-0 text-left'
            icon={context.portalConfiguration.iconPdfSrc}
            iconPos='left'
            pt={{ label: { className: 'text-[16px] font-semibold leading-[24px]' }, icon: { className: 'text-[16px]' } }}
            onClick={async () => {
              const fileResp = await context?.httpClient?.downloadFile({ input: attach.resourceLink! }, attach.name)
              if (fileResp?.fetchError || fileResp?.blobError || !fileResp?.httpResponse || !fileResp.httpResponse.ok) {
                context.showToastMessage({ severity: 'error', summary: tErr.t('DownloadFileErrorMessage') })
              }
            }}
          />
        </div>
      ))}
    </div>
  )
}
